const parseAmount = (value: string): number =>
  parseFloat(value.replace(/\s/g, "").replace(",", ".")) || 0;

export default parseAmount;
